import { render, staticRenderFns } from "./LeftMain.vue?vue&type=template&id=fac01220"
import script from "./LeftMain.vue?vue&type=script&lang=js"
export * from "./LeftMain.vue?vue&type=script&lang=js"
import style0 from "./LeftMain.vue?vue&type=style&index=0&id=fac01220&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports